import styled from 'styled-components';

export const NotificationBanner = styled.div`
  white-space: pre-line;
`;
